var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnCncelS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "btn_cncel_s",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.999,
    height: 9.999,
    viewBox: "0 0 9.999 9.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4213",
    "data-name": "\\uD328\\uC2A4 4213",
    d: "M.283,8.615,1.321,9.668a.986.986,0,0,0,1.394.01L4.982,7.444,7.216,9.71a.986.986,0,0,0,1.394.01L9.662,8.683a.986.986,0,0,0,.01-1.394L7.438,5.022,9.705,2.788a.986.986,0,0,0,.01-1.394L8.677.341A.986.986,0,0,0,7.283.33L5.016,2.565,2.782.3A.986.986,0,0,0,1.388.289L.336,1.326A.986.986,0,0,0,.326,2.72L2.56,4.987.293,7.222A.985.985,0,0,0,.283,8.615Z",
    transform: "translate(0.001 -0.005)",
    fill: "#3c3c3c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCncelS);
export default __webpack_public_path__ + "static/media/btn_cncel_s.b737e653fcda844f1a239768879167b3.svg";
export { ForwardRef as ReactComponent };